import React from "react";
import { useRetractableBar } from "@/hooks/useRetractableBar";

interface GlobalFooterProps {
  shouldRetract?: boolean;
}

const GlobalFooter: React.FC<GlobalFooterProps> = ({ shouldRetract = false }) => {
  const { isVisible, hasMounted } = useRetractableBar({ shouldRetract, edge: "bottom" });

  return (
    <footer
      className={`fixed bottom-0 left-0 right-0 z-[60] bg-background shadow-elegant border-t border-border/50
        transition-all duration-1000 ease-in-out
        ${!hasMounted ? "translate-y-full" : isVisible ? "translate-y-0" : "translate-y-[calc(100%-8px)]"}
      `}
    >
      <div className="flex flex-col md:flex-row md:items-center md:justify-between px-6 py-3 gap-2">
        <div className="text-sm text-muted-foreground text-left">
          © 2025 Carline Consensor, LLC.<span className="hidden md:inline"> All rights reserved.</span>
        </div>

        <div className="text-sm text-muted-foreground text-right md:text-left">
          Contact us:{" "}
          <a href="mailto:contact@carlineconsensor.com" className="text-primary hover:underline">
            contact@carlineconsensor.com
          </a>
        </div>
      </div>
    </footer>
  );
};

export default GlobalFooter;
